import { CodeBook } from "@king-ict/eupisi-ui/models";

import type { ProgramMinisterDetailDto } from "./EditProgramCodeBookRequest";

export interface ProgramCodeBook extends CodeBook {
  code: string;
  programTypeEMaticaId?: number;
  programTypeEMaticaName: string;
  programTypeId: number;
  programTypeName: string;
  qualificationTypeId?: number;
  qualificationType?: string;
  hkoLevelId: number | null;
  hkoLevelName: string;
  educationSectorId?: number;
  educationSectorName: string;
  educationSubSectorId?: number;
  educationSubSectorName: string;
  qualificationId?: number;
  qualificationName: string;
  professionFieldId?: number,
  professionFieldName: string,
  languageId?: number;
  languageName: string;
  professionId?: number;
  professionName: string;
  programWithMinisterResolution?: boolean;
  ministerDetail?: ProgramMinisterDetailDto | null;
  dateTo?: Date;
  canDelete: boolean;
}

export const createProgramMinisterDetailInitial = (): ProgramMinisterDetailDto => ({
  hkoLevelText: "",
  educationSectorText: "",
  educationSubSectorText: "",
  guidedLearningDuration: 0,
  independentLearningDuration: 0,
  workLearningDuration: 0,
  formOfTeachingIds: [],
  otherFormsOfTeaching: [],
  enrollmentConditionIds: [],
  otherEnrollmentConditions: [],
  knowledgeCheckIds: [],
  otherKnowledgeChecks: [],
  competences: [""],
  modules: [{ name: "", learningSets: [{ name: "", code: "", level: 2, csvet: 1 }] }],
});

export const programInitial = (): ProgramCodeBook => {
  return {
    id: 0,
    name: "",
    code: "",
    programTypeEMaticaId: 0,
    programTypeEMaticaName: "",
    programTypeId: 0,
    hkoLevelName: "",
    programTypeName: "",
    hkoLevelId: 0,
    educationSectorId: 0,
    educationSectorName: "",
    educationSubSectorId: 0,
    educationSubSectorName: "",
    qualificationId: 0,
    qualificationName: "",
    professionFieldId: 0,
    professionFieldName: "",
    languageId: 0,
    languageName: "",
    professionId: 0,
    professionName: "",
    programWithMinisterResolution: false,
    ministerDetail: null,
    canDelete: false
  }
}
